const API_BASE_URL = process.env.REACT_APP_RECRUIT_API_URL || 'http://localhost:8080';

async function request(path, options = {}) {
    const res = await fetch(`${API_BASE_URL}${path}`, {
        ...options,
        headers: { 'Content-Type': 'application/json', ...options.headers },
    });
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        const error = new Error(body.message || '요청에 실패했습니다.');
        error.status = res.status;
        throw error;
    }
    const text = await res.text();
    if (!text) return null;
    return JSON.parse(text);
}

export const jobOfferRepository = {
    sendOffer: (accessToken, jobSeekerRequestId, recruitmentRequestId, message) =>
        request('/api/job-offers', {
            method: 'POST',
            headers: { Authorization: `Bearer ${accessToken}` },
            body: JSON.stringify({ jobSeekerRequestId, recruitmentRequestId, message }),
        }),

    getReceivedOffers: (accessToken) =>
        request('/api/job-offers/received', {
            headers: { Authorization: `Bearer ${accessToken}` },
        }),

    checkOffered: (accessToken, jobSeekerRequestId) =>
        request(`/api/job-offers/check?jobSeekerRequestId=${jobSeekerRequestId}`, {
            headers: { Authorization: `Bearer ${accessToken}` },
        }),

    getSentOffers: (accessToken) =>
        request('/api/job-offers/sent', {
            headers: { Authorization: `Bearer ${accessToken}` },
        }),

    withdrawOffer: (accessToken, offerId) =>
        request(`/api/job-offers/${offerId}/withdraw`, {
            method: 'PATCH',
            headers: { Authorization: `Bearer ${accessToken}` },
        }),
};
